const formMetadata = {
    firstName: {
        name: "First Name",
        isRequired: true,
        defaultValue: ""
    },
    lastName: {
        name: "Last Name",
        isRequired: true,
        defaultValue: ""
    },
    businessName: {
        name: "Business Name",
        isRequired: true,
        defaultValue: ""
    },
    email: {
        name: "Email",
        isRequired: true,
        defaultValue: ""
    },
    phoneNumber: {
        name: "Phone Number",
        isRequired: true,
        defaultValue: ""
    },
    city: {
        name: "City",
        isRequired: true,
        defaultValue: ""
    },
    state: {
        name: "State",
        isRequired: true,
        defaultValue: ""
    },
    contactPreferences: {
        name: "Contact Preference",
        isRequired: false,
        defaultValue: ""
    },
    hearAbout: {
        name: "How did you hear about us?",
        isRequired: false,
        defaultValue: ""
    },
    userConfigId: {
        name: "UCID",
        isRequired: false,
        defaultValue: ""
    },
    leadSource: {
        name: "Lead Source",
        isRequired: false,
        defaultValue: ""
    },
    campaignId: {
        name: "Campaign Id",
        isRequired: false,
        defaultValue: ""
    },
    referringDomain: {
        name: "Referrer",
        isRequired: false,
        defaultValue: ""
    },
    paidSearch: {
        name: "Paid Search",
        isRequired: false,
        defaultValue: ""
    },
    visitId: {
        name: "Visit Id",
        isRequired: false,
        defaultValue: ""
    },
    icId: {
        name: "IcId",
        isRequired: false,
        defaultValue: ""
    },
};

export default formMetadata;